import { Injectable } from '@angular/core';
import math from 'mathjs';
@Injectable()
export class ConversionFormulas {
  public convertHRAtoUTS = (hardness: number): number => {
    return 9 * hardness + math.pow(hardness / 28.0, 7.0);
  };

  public convertHBStoHRA = (hardness: number): number => {
    return this.convertHRBtoHRA(this.convertHBStoHRB(hardness, 'HRA'));
  };

  public convertHBStoHRB = (hardness: number, hra: string = ''): number => {
    let HRBArray = [
      0,
      2,
      3,
      5,
      6,
      7,
      8,
      10,
      11,
      12,
      13,
      15,
      16,
      17,
      18,
      20,
      21,
      22,
      23,
      25,
      26,
      27,
      28,
      29,
      31,
      32,
      33,
      34,
      35,
      36,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58,
      59,
      60,
      61,
      62,
      63,
      64,
      64,
      65,
      66,
      67,
      68,
      68,
      69,
      70,
      71,
      71,
      72,
      73,
      73,
      74,
      75,
      75,
      76,
      76,
      77,
      78,
      78,
      79,
      79,
      80,
      80,
      81,
      81,
      82,
      82,
      83,
      83,
      83,
      84,
      84,
      85,
      85,
      85,
      86,
      86,
      86,
      87,
      87,
      88,
      88,
      88,
      89,
      89,
      89,
      89,
      90,
      90,
      90,
      91,
      91,
      91,
      91,
      92
    ];

    if (hra === '') {
      if (hardness >= 70) {
        return HRBArray[hardness - 48];
      } else {
        return 0;
      }
    } else if (hardness >= 48) {
      return HRBArray[hardness - 48];
    } else {
      return 0;
    }
  };

  public convertHRBtoHBS = (hardness: number): number => {
    let hbs =
      1 /
      (0.0209261 -
        0.000313747 * hardness +
        0.0000032472 * math.pow(hardness, 2) -
        0.0000000171476 * math.pow(hardness, 3));

    return hbs > 160 ? 0 : 5 * math.round(hbs / 5);
  };

  public convertHRBtoHBW = (hardness: number): number => {
    let BHNArray = [
      100,
      101,
      103,
      104,
      106,
      107,
      108,
      110,
      112,
      114,
      116,
      117,
      119,
      121,
      123,
      125,
      127,
      130,
      132,
      135,
      137,
      139,
      141,
      144,
      147,
      150,
      153,
      156,
      159,
      162,
      165,
      169,
      172,
      176,
      180,
      185,
      190,
      195,
      200,
      205,
      210,
      216,
      222,
      228,
      234,
      240
    ];

    return hardness >= 55 ? BHNArray[hardness - 55] : 0;
  };

  public convertHBWtoHRA = (hardness: number): number => {
    let hrb = this.convertHBWtoHRB(hardness, false);
    let hrc = this.convertHBWtoHRC(hardness, false);
    let minHBW = 225;
    let maxHBW = 241;

    if (hardness < minHBW) {
      return this.convertHRBtoHRA(hrb);
    } else if (hardness > maxHBW) {
      return this.convertHRCtoHRA(hrc);
    } else {
      return (
        (this.convertHRCtoHRA(hrc) * (hardness - minHBW) + this.convertHRBtoHRA(hrb) * (maxHBW - hardness)) /
        (maxHBW - minHBW)
      );
    }
  };

  public convertHBWtoHRB = (hardness: number, validate: boolean = true): number => {
    let hrb = 114.665 + 0.0882795 * hardness - 0.000141855 * math.pow(hardness, 2) - 6695.28 / hardness;
    return hrb > 100 && validate ? 0 : hrb;
  };

  public convertHBWtoHRC = (hardness: number, validate: boolean = true): number => {
    let hrc: number = 18.1673 + 0.120388 * hardness - 0.0000694388 * math.pow(hardness, 2) - 4883.27 / hardness;
    return hrc < 20 && validate ? 0 : hrc;
  };

  public convertHRCtoHBW = (hardness: number): number => {
    let BHNArray = [
      226,
      231,
      237,
      243,
      247,
      253,
      258,
      264,
      271,
      279,
      286,
      294,
      301,
      311,
      319,
      327,
      336,
      344,
      353,
      362,
      371,
      381,
      390,
      400,
      409,
      421,
      432,
      443,
      455,
      469,
      481,
      496,
      512,
      525,
      543,
      560,
      577,
      595,
      615,
      634,
      654
    ];

    return hardness < 61 ? BHNArray[hardness - 20] : 0;
  };

  public convertHRCtoHRA = (hardness: number): number => {
    return (2.76747 - math.sqrt(math.pow(2.76747, 2) - 0.02376712 * (125.501 + hardness))) / 0.01188356;
  };

  public convertHRBtoHRA = (hardness: number): number => {
    return (3.33354 - math.sqrt(math.pow(3.33354, 2) - 0.0600428 * (48.235 + hardness))) / 0.0300214;
  };

  public convertRpmToSfm = (speed: number, diameter: number): number => {
    return (math.PI * diameter * speed) / 12;
  };

  public convertSfmToRpm = (surfaceSpeed: number, endmillDiameter: number): number => {
    return endmillDiameter > 0 ? (surfaceSpeed * 12) / (math.PI * endmillDiameter) : 0;
  };

  public convertIpmToIpt = (speed: number, feed: number, fluteCount: number): number => {
    return speed > 0 && fluteCount > 0 ? feed / (speed * fluteCount) : 0;
  };

  public convertIptToIpm = (speed: number, fpt: number, fluteCount: number): number => {
    return speed * fluteCount * fpt;
  };

  public convertTeaToRdoc = (engageAngle: number, endmillDiameter: number, fillet: number = 0) => {
    let angleRad = (math.PI * engageAngle) / 180;
    let cutWidth = (endmillDiameter * (1 - math.cos(angleRad))) / 2;

    if (fillet > 0) {
      let toolRadius = endmillDiameter / 2;
      let pathRadius = fillet - toolRadius;

      cutWidth =
        fillet -
        math.sqrt(
          math.pow(pathRadius, 2) +
            math.pow(toolRadius, 2) -
            pathRadius * endmillDiameter * math.cos(math.PI - angleRad)
        );
    }

    return cutWidth;
  };

  public convertRdocToTea = (cutWidth: number, endmillDiameter: number, fillet: number = 0) => {
    let angleRad;
    if (endmillDiameter > 0) {
      angleRad = math.acos((endmillDiameter - 2 * cutWidth) / endmillDiameter);

      if (fillet > 0) {
        let toolRadius = endmillDiameter / 2;
        let pathRadius = fillet - toolRadius;
        let numerator = math.pow(pathRadius, 2) + math.pow(toolRadius, 2) - math.pow(fillet - cutWidth, 2);
        let denominator = pathRadius * endmillDiameter;

        angleRad = math.abs(numerator) > denominator ? math.PI : math.PI - math.acos(numerator / denominator);
      }

      return (180 * angleRad) / math.PI;
    }

    return 0;
  };
}
